import React from 'react';
import styled from 'styled-components';
import { ILokalPlanFeatureProperties } from '../../../Interfaces/ILokalplan';
import {
  arrayStringToArray,
  dateNumberToDate,
  datePropertyToDateString,
} from '../../../util';
import Anvendelse from '../Lokalplan/Anvendelse';

const HistoriskLokalplanInfo = (props: IHistoriskLokalplanInfoPropTypes) => {
  const { properties } = props;
  const {
    anvspec,
    datoikraft,
    anvgen,
    datoopdt,
    bygomfang: bygomfangString,
  } = properties;
  const bygomfang = bygomfangString ? JSON.parse(bygomfangString) : [];
  const anvspecListe = arrayStringToArray(anvspec);
  const keys = new Set();
  const uniqueanvspecListe = anvspecListe.filter(anvspec => {
    if (keys.has(anvspec)) {
      return false;
    }
    keys.add(anvspec);
    return true;
  });
  const gaeldendeFra = datoikraft
    ? dateNumberToDate(datoikraft).toLocaleDateString('da-DK')
    : '';
  const specifikeAnvendelser = uniqueanvspecListe.map(kode => {
    const bygomf = bygomfang.find(b => b.anvspec === parseInt(kode));
    return (
      <Anvendelse
        kode={parseInt(kode)}
        key={kode}
        bygomfang={bygomf}
        omfangBgColor={'#E4EAEF'}
      />
    );
  });
  return (
    <Wrapper>
      <h2>Lokalplan</h2>
      <h3>I kraft fra</h3>
      <div
        style={{
          display: 'flex',
        }}
      >
        <span style={{ marginLeft: 10 }}>{gaeldendeFra}</span>
      </div>

      <h3>Opdateret</h3>
      <span style={{ marginLeft: 10 }}>
        {datePropertyToDateString(datoopdt)}
      </span>
      <h3>Generel anvendelse</h3>
      <Anvendelser>
        <Anvendelse kode={anvgen} />
      </Anvendelser>
      <h3>Specifik anvendelse</h3>
      <Anvendelser>{specifikeAnvendelser}</Anvendelser>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  padding: 14px 25px;

  h3 {
    color: #9aa2a7;
  }
`;

const Anvendelser = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
interface IHistoriskLokalplanInfoPropTypes {
  properties: ILokalPlanFeatureProperties;
}

export default HistoriskLokalplanInfo;
